export default __webpack_public_path__ + "static/media/2.41d84077.jpg";